import "./App.css";
import HomePage from "./components/home";

function App() {
  return <HomePage></HomePage>;
}

export default App;
